// import components
import { styled } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

export const StyledExtraSmallIcon = styled(Icon)(() => ({
  '&&': {
    height: '16px',
    width: '16px'
  }
}));

export const StyledSmallerIcon = styled(Icon)(() => ({
  '&&': {
    height: '18px',
    width: '18px'
  }
}));
